// @flow
import React, { useState, Fragment } from 'react';
import IncomeFields from '../IncomeFields';
import IncomeSummary from '../IncomeSummary/';

import type { Income } from '../IncomeCalculator';
import type { DateObject } from '@cmsgov/ds-healthcare-gov';
import type { FrequencyType } from '../../../common/enums/FrequencyTypes';
import type { IncomeType } from '../../../common/enums/IncomeTypes';

type Props = {
  id: string,
  editing: boolean,
  incomeType: IncomeType,
  incomeTypeIndex: ?number,
  incomeFrequency: FrequencyType,
  amount: string,
  startDate: ?DateObject,
  endDate: ?DateObject,
  calculatedTotal: number,
  onUpdateIncomeEntry: (incomeState: Income, id: string) => void,
  onRemoveIncome: (id: string) => void,
  showHelpDrawer: ({ heading: string, body: string }) => void,
  activeHelpDrawer?: string,
};

export const IncomeRow = (props: Props) => {
  const [editing, setEditing] = useState<boolean>(props.editing);

  const handleDoneClick = (incomeState: Income) => {
    props.onUpdateIncomeEntry(incomeState, props.id);
    setEditing(false);
  };

  const handleCancelClick = () => {
    setEditing(false);
  };

  return (
    <Fragment>
      {editing ? (
        <IncomeFields
          incomeType={props.incomeType}
          amount={props.amount}
          startDate={props.startDate}
          endDate={props.endDate}
          incomeFrequency={props.incomeFrequency}
          calculatedTotal={props.calculatedTotal}
          onCancelAddIncome={handleCancelClick}
          onDoneClick={handleDoneClick}
          showHelpDrawer={props.showHelpDrawer}
          activeHelpDrawer={props.activeHelpDrawer}
        />
      ) : (
        <IncomeSummary
          onEditClick={() => setEditing(true)}
          amount={props.amount}
          incomeType={props.incomeType}
          incomeTypeIndex={props.incomeTypeIndex}
          incomeFrequency={props.incomeFrequency}
          calculatedTotal={props.calculatedTotal}
          startDate={props.startDate}
          endDate={props.endDate}
          onRemoveIncome={() => props.onRemoveIncome(props.id)}
        />
      )}
    </Fragment>
  );
};

export default IncomeRow;
